@if (parkingReimbursements.length > 0) {
  <tidy-card>
    <tidy-row>
      <tidy-text
        [header]="'Parking Reimbursement Request'" />
    </tidy-row>
    @for (parkingReimbursement of parkingReimbursements; track parkingReimbursement) {
      <tidy-row>
        <tidy-text
          [body]="(' Your pro ' | translate) + parkingReimbursement?.homekeeper?.name + (' is requesting reimbursement for ' | translate) + (parkingReimbursement.amount | tcurrency) + (' that they paid for parking during this cleaning. 100% of reimbursement goes to the pro.' | translate)" />
      </tidy-row>
      <ion-row>
        <ion-col style="text-align: center">
          <div (click)="responseRequest(cleaningId, parkingReimbursement.id, 'rejected')" class="parking-btn reject-btn">
            <div class="reject-icon parking-icon"></div>
          </div>
          <tidy-text
            [body]="'Reject Request - Pay Max of $0'" />
        </ion-col>
        <ion-col style="text-align: center">
          <div (click)="responseRequest(cleaningId, parkingReimbursement.id, 'approved')" class="parking-btn approve-btn">
            <div class="approve-icon parking-icon"></div>
          </div>
          <tidy-text
            [body]="('Accept Request - Pay ' | translate) + (parkingReimbursement.amount | tcurrency)" />
        </ion-col>
      </ion-row>
      <tidy-row class="extra-top-padding">
        <img [src]="parkingReimbursement.photo_url">
      </tidy-row>
    }
  </tidy-card>
}
